import { render, staticRenderFns } from "./SearchGudangkuIFrame.vue?vue&type=template&id=5b6a20e9&"
import script from "./SearchGudangkuIFrame.vue?vue&type=script&lang=js&"
export * from "./SearchGudangkuIFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports